import React from 'react'
import './header.css'

const Header = () => {
  return (
    <div>Header</div>
  )
}

export default Header